import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SetScreenSize } from '../actions/breakpoint.actions';
import { BreakpointFacadeService } from './breakpoint.facade.service';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  constructor(
    private responsive: BreakpointObserver,
    private facade: BreakpointFacadeService
  ) {}

  Size(): Observable<string> {
    return this.responsive
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(
        map((result) => {
          if (result.matches) {
            if (result.breakpoints[Breakpoints.XSmall]) {
              this.facade.dispatch(SetScreenSize({ size: 'XSmall' }));
            } else if (result.breakpoints[Breakpoints.Small]) {
              this.facade.dispatch(SetScreenSize({ size: 'Small' }));
            } else if (result.breakpoints[Breakpoints.Medium]) {
              this.facade.dispatch(SetScreenSize({ size: 'Medium' }));
            } else if (result.breakpoints[Breakpoints.Large]) {
              this.facade.dispatch(SetScreenSize({ size: 'Large' }));
            } else if (result.breakpoints[Breakpoints.XLarge]) {
              this.facade.dispatch(SetScreenSize({ size: 'XLarge' }));
            }
          }
          return '';
        })
      );
  }
}
